const Prefixes = [
    { id: 'Mr', name: 'Mr' },
    { id: 'Ms', name: 'Ms' },
    { id: 'Dr', name: 'Dr' },
];

export default Prefixes;



// WEBPACK FOOTER //
// ./src/models/Prefixes.ts